import { Pipe, PipeTransform } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { WEEKDAY } from '../models';

@Pipe({
  name: 'smartWeekdayFormatter',
  pure: false,
})
export class SmartWeekdayFormatterPipe implements PipeTransform {
  constructor(private translateService: TranslateService) {}

  transform(weekdays: WEEKDAY[], ...args: any[]): any {
    if (!weekdays?.length) {
      return '';
    }

    const weekdayAsStr = [
      WEEKDAY.MONDAY,
      WEEKDAY.TUESDAY,
      WEEKDAY.WEDNESDAY,
      WEEKDAY.THURSDAY,
      WEEKDAY.FRIDAY,
      WEEKDAY.SATURDAY,
      WEEKDAY.SUNDAY,
    ];

    const sortedWeekdays = this.sortWeekdays(weekdays);

    let smartWeekdayStr = '';

    for (let i = 0; i < sortedWeekdays.length; ) {
      if (smartWeekdayStr.length) {
        smartWeekdayStr += ', ';
      }
      smartWeekdayStr += this.translateService.instant(
        `pipes.weekday.${sortedWeekdays[i]}`
      );

      if (i === sortedWeekdays.length - 1) {
        break;
      }

      let j = i + 1;
      for (; j < sortedWeekdays.length; j += 1) {
        const nextWeekdayAsNr = weekdayAsStr.indexOf(sortedWeekdays[j]);
        const previousWeekdayAsNr = weekdayAsStr.indexOf(sortedWeekdays[j - 1]);

        if (previousWeekdayAsNr + 1 !== nextWeekdayAsNr) {
          break;
        }
      }

      j -= 1;

      if (j > i + 1) {
        smartWeekdayStr +=
          ' ' +
          this.translateService.instant('pipes.text.to') +
          ' ' +
          this.translateService.instant(`pipes.weekday.${sortedWeekdays[j]}`);
        i = j + 1;
      } else {
        i += 1;
      }
    }

    return smartWeekdayStr;
  }

  private sortWeekdays(weekdays: WEEKDAY[]): WEEKDAY[] {
    const weekdayAsStr = [
      WEEKDAY.MONDAY,
      WEEKDAY.TUESDAY,
      WEEKDAY.WEDNESDAY,
      WEEKDAY.THURSDAY,
      WEEKDAY.FRIDAY,
      WEEKDAY.SATURDAY,
      WEEKDAY.SUNDAY,
    ];
    const weekdayAsNr = weekdays
      .map((w) => weekdayAsStr.indexOf(w))
      .filter((w) => w >= 0);

    weekdayAsNr.sort();
    return weekdayAsNr.map((w) => weekdayAsStr[w]);
  }
}
